<ng-template #aamBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('document.save-document-first' | translate)
                : ('document.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'document.save-document-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #aamBlock
    [class]="blockableClass"
    [style]="blockedStyle"
    [blocked]="isBlocked"
    [blockUi]="aamBlockUi"
>
    @if (document?.id) {
        <div class="w-full">
            <div style="text-align: center; margin: 1em">
                @if (isComponentRendered()) {
                    <app-asset-file-input
                        (selectFiles)="createAssets($event)"
                        [noUploadButton]="true"
                        [dropZoneTargetModelSig]="assetListWidget().table.el ?? undefined"
                    />
                }
            </div>
            <app-widget-asset-list
                #assetList
                [autoFocusSearch]="false"
                [showEmailButton]="true"
                [showUploadButton]="true"
                [fillHeightList]="false"
                [dataTestId]="'formly-document-assets'"
                (isComponentRendered)="isComponentRendered.set(true)"
                (selectFiles)="createAssets($event)"
                [modelIdSig]="document.id"
                [modelTypeSig]="'DocumentAsset'"
                [noDelete]="checkIfNoDelete()"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'common.journal-entries' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-journal-list-widget
                #journalListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'task.task-list' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-task-list-widget
                #taskListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />
        </div>
    }
</blockable-div>
